/* eslint-disable */
import axios from "axios"

const baseUrl = process.env.VUE_APP_BASE_API + "/excursion/dashboard/";


const state = {

}

const actions = {
    async summaryDay({
        commit
    }, payload) {
        return axios
            .get(
                baseUrl + "summary_whole_day/" +
                "?day=" + payload.day 
                //"&activity_group_id=" + payload.activity_group_id
            )
            .then(response => {
                return response.data
            })
    },
    async planningDay({
        commit
    }, payload) {
        return axios
            .get(
                baseUrl + "planning_day/" +
                "?day=" + payload.day
            )
            .then(response => {
                return response.data
            })
    }
}

const mutations = {

}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}